import type { IntlShape } from 'react-intl'
import type { PaymentHeader, PaymentFormInput } from './types'

export const paymentHeaders: PaymentHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksu',
				description: 'Table column header: uuid',
			}),
		key: 'uuid', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header: date',
			}),
		key: 'date', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Table column header: Additional information',
			}),
		key: 'additionalInformation', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksettu',
				description: 'Table column header: Paid',
			}),
		key: 'paid', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Table column header: Currency',
			}),
		key: 'currency', //TODO:
		show: true,
		sortable: true,
		type: 'string',
	},
]

export const paymentFormHeaders: PaymentFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksupäivä',
				description: 'Payment date',
			}),
		key: 'paymentDate', //TODO:
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritustapa',
				description: 'Payment method',
			}),
		key: 'paymentMethod', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Additional information',
			}),
		key: 'additionalInformation', //TODO:
		show: true,
		type: 'string',
		fullWidth: true,
	},
]

export const paymentFormTableHeaders: PaymentFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lasku',
				description: 'Invoice',
			}),
		key: 'invoice', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tilinumero',
				description: 'Account number',
			}),
		key: 'accountNumber', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yritys',
				description: 'Company',
			}),
		key: 'company', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksettu',
				description: 'Paid',
			}),
		key: 'paid', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Currency',
			}),
		key: 'currency', //TODO:
		show: true,
		type: 'string',
	},
]
